module.exports = {"token_service":{"production":"lts-{server}.xz.163.com","test":"lts-{server}.xz.163.com"}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/services.zh.json
// module id = 420
// module chunks = 0